import script from "./WhatWeDo.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&setup=true&lang=js"

import "./WhatWeDo.vue?vue&type=style&index=0&id=52a00032&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a00032"]])

export default __exports__